import axios from 'axios';
import { toast } from 'react-toastify';
import API from '../../config/apiconfig';
import { userLoginSuccess, userLogout } from '../../action/userActions';
import store from "../../store/store";

const axiosInstance = axios.create();

axiosInstance.interceptors.request.use(
    (config) => {
      const state = store.getState();
      const token = state.user?.accessToken;
  
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
      }
  
      config.headers['Ocp-Apim-Subscription-Key'] = process.env.REACT_APP_SUBSCRIPTION_KEY;
  
      return config;
    },
    (error) => Promise.reject(error)
  );
  

  axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
      const originalRequest = error.config;
  
      if (originalRequest.url.includes(API.REFRESH_TOKEN)) {
        return Promise.reject(error);
      }
  
      if (error.response?.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;
  
        const state = store.getState();
        const refreshToken = state.user?.refreshToken;
  
        if (!refreshToken) {
          toast.error('No refresh token found. Please log in again.');
          store.dispatch(userLogout());
          window.location.href = '/';
          return Promise.reject(error);
        }
  
        return axios.post(`${API.USER_MANAGEMENT_API_BASE_URL}${API.REFRESH_TOKEN}`, {
          refresh_token: refreshToken
        }, {
          headers: {
            'Content-Type': 'application/json',
            'Ocp-Apim-Subscription-Key': process.env.REACT_APP_SUBSCRIPTION_KEY,
          }
        }).then((res) => {
          if (res.status === 200) {
            const { access_token: newAccessToken, refresh_token: newRefreshToken } = res.data;
  
            store.dispatch(
              userLoginSuccess({
                ...state.user,
                accessToken: newAccessToken,
                refreshToken: newRefreshToken,
              })
            );
            originalRequest.headers['Authorization'] = `Bearer ${newAccessToken}`;
            originalRequest.headers['Ocp-Apim-Subscription-Key'] = process.env.REACT_APP_SUBSCRIPTION_KEY;

            console.log(originalRequest);
            
  
            return axiosInstance(originalRequest); 
          } else {
            toast.error('Session expired. Please log in again.');
            store.dispatch(userLogout());
            window.location.href = '/';
            return Promise.reject(error);
          }
        }).catch((refreshError) => {
          console.error('Refresh failed:', refreshError.response?.data || refreshError.message);
          toast.error('Session expired. Please log in again.');
          store.dispatch(userLogout());
          window.location.href = '/';
          return Promise.reject(refreshError);
        });
      }
  
      return Promise.reject(error);
    }
  );
  
  

export default axiosInstance;
